import axios from "../../axios";
import { isPlatformOnly } from "../langs";

// Курс платформних уроків з групи й рівня матеріалів: adults + beginner → "adults-beginner".
// Інші мови — з префіксом мови, щоб не злитися з англійськими курсами: es + kids + A1 → "es-kids-a1"
export const coursePrefix = (lang) => (lang && lang !== "en" ? `${lang}-` : "");
export const courseOf = (group, level, lang) =>
  group && level ? `${coursePrefix(lang)}${group}-${String(level).trim().toLowerCase().replace(/\s+/g, "-")}` : null;

// Особливі «рівні» курсів платформи: пробний урок лежить у групі окремо від рівнів (es-kids-trial → «Пробний урок»), першим у списку
export const LEVEL_LABELS = { trial: "Пробний урок" };
export const levelLabel = (level) => LEVEL_LABELS[level] || level;
export const sortLevels = (levels) => [...levels].sort((a, b) => (b === "trial") - (a === "trial"));

// Уроки курсу (без слайдів). Учням сервер віддає лише опубліковані
export const fetchPlatformLessons = async (course) => {
  if (!course) return [];
  const { data } = await axios.get("platform-lessons", { params: { course } });
  return Array.isArray(data) ? data : [];
};

// Усі уроки платформи (для «Матеріали → Уроки платформи»: які групи/рівні вже мають уроки)
export const fetchAllPlatformLessons = async () => {
  const { data } = await axios.get("platform-lessons");
  return Array.isArray(data) ? data : [];
};

// Посилання на урок у «Матеріалах» / звіті по уроку — так платформні уроки відрізняються від Canva
export const platformLessonUrl = (lessonId) => `/present/${lessonId}`;
export const isPlatformLessonUrl = (url = "") => String(url).startsWith("/present/");

// Джерело матеріалів учня (поле materialsSource у картці): "platform" | "canva" (за замовчуванням — Canva).
// Платформа діє лише якщо для групи+рівня учня є уроки платформи, інакше показуємо Canva — учень не лишиться без уроків.
export const MATERIALS_SOURCES = [
  { value: "platform", name: "Уроки платформи" },
  { value: "canva", name: "Canva" },
];
// Мова без Canva (іспанська) — завжди платформа, незалежно від картки
export const wantsPlatform = (student) => isPlatformOnly(student?.accessType) || student?.materialsSource === "platform";

// Чи є уроки платформи для групи+рівня (курси: adults-beginner, …). Для форми додавання й картки учня
export const fetchPlatformCourses = async () => {
  const lessons = await fetchAllPlatformLessons().catch(() => []);
  return [...new Set(lessons.map((lesson) => lesson.course))];
};
